import React, { useRef, useEffect, ReactNode } from "react";

interface HighlightCellProps {
   active: boolean;
   children: ReactNode;
   style?: React.CSSProperties;
}

const ColumnsItem: React.FC<HighlightCellProps> = ({ active, children, style }) => {
   const cellRef = useRef<HTMLDivElement>(null);

   useEffect(() => {
      if (cellRef.current) {
         const td = cellRef.current.closest("td");
         if (td) {
            td.style.backgroundColor = active ? "#16B16A33" : "white";
            td.style.position = "relative";
         }
      }
   }, [active]);

   return (
      <div
         ref={cellRef}
         style={{
            ...style,
            color: active ? "black" : "",
         }}
      >
         {children}
      </div>
   );
};

export default ColumnsItem;
